import * as React from 'react';
import Styled, { css } from 'styled-components';

import BaseButton from './BaseButton';
import { IButtonProps } from './common';

const DisabledButton = Styled(BaseButton)<IButtonProps>`
  background: ${({ theme: { button: { alert } } }) => alert.colorBackgroundDisabled};
  border: ${({ theme: { button } }) => `${button.borderWidth} solid ${button.alert.colorBorderDisabled}`};
  color: ${({ theme: { button: { alert } } }) => alert.colorTextDisabled};
  cursor: not-allowed;

  svg {
    fill: currentColor;
  }
`;

const ActiveButton = Styled(BaseButton)<IButtonProps>`
  background: ${({ theme: { button: { alert } } }) => alert.colorBackground};
  border: ${({ theme: { button } }) => `${button.borderWidth} solid ${button.alert.colorBorder}`};
  color: ${({ theme: { button: { alert }} }) => alert.colorText};

  ${({ isLoading }) => !isLoading && css`
    &:hover {
      background: ${({ theme: { button: { alert }} }) => alert.colorBackgroundHover};
      border: ${({ theme: { button } }) => `${button.borderWidth} solid ${button.alert.colorBorderHover}`};
      color: ${({ theme: { button: { alert } } }) => alert.colorTextHover};
    }

    &:focus,
    &:active {
      background: ${({ theme: { button: { alert }} }) => alert.colorBackgroundFocus};
      border: ${({ theme: { button } }) => `${button.borderWidth} solid ${button.alert.colorBorderHover}`};
      color: ${({ theme: { button: { alert } } }) => alert.colorTextHover};
      ${({ theme: {button: { alert }}}) => alert.colorBorderFocus && css`
        border-color: ${alert.colorBorderFocus};
      `}
    }

    &:hover,
    &:focus,
    &:active {
      svg {
        fill: CurrentColor;
      }
    }
  `}
`;

export const AlertButton: React.FunctionComponent<IButtonProps> = props => (
  props.disabled && !props.isLoading ? <DisabledButton {...props} /> : <ActiveButton {...props} />
);

AlertButton.displayName = 'AlertButton';

export default AlertButton;
